import adminApi from './adminApi';

export interface UnknownLocationReport {
  id: number;
  childId: number;
  childName: string;
  parentId: number;
  reportType: 'UNKNOWN_SCHOOL' | 'UNKNOWN_COUNCIL';
  councilId: number | null;
  councilName: string;
  schoolType: string;
  reportedSchoolName: string;
  status: 'PENDING' | 'RESOLVED';
  createdAt: string;
  resolutionType: string | null;
  resolvedSchoolId: number | null;
  resolvedSchoolName: string | null;
  resolvedBy: number | null;
  resolvedAt: string | null;
  /** Cross-child duplicate: another PENDING report has same councilName+schoolType+reportedSchoolName (FR-013). */
  isDuplicate: boolean;
  /** Same-child duplicate: this child already has another PENDING report with identical type+name (FR-017). */
  isDuplicateChild: boolean;
}

export interface ResolveReportRequest {
  resolutionType: 'LINKED_EXISTING' | 'ADDED_AND_LINKED' | 'CORRECTED_COUNCIL';
  resolvedSchoolId: number | null;
  resolvedSchoolName: string;
  applyToDuplicates: boolean;
}

export interface BulkResolveResult {
  resolvedCount: number;
  resolvedSchoolName: string;
  matchingPendingCount: number;
}

export interface PagedReports {
  content: UnknownLocationReport[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

const BASE = '/api/admin/unknown-location-reports';

export const unknownLocationService = {
  getReports: async (status?: string, reportType?: string, page = 0, size = 20): Promise<PagedReports> => {
    const params: Record<string, string | number> = { page, size };
    if (status) params.status = status;
    if (reportType) params.reportType = reportType;
    const response = await adminApi.get<{ data: PagedReports }>(BASE, { params });
    return response.data.data;
  },

  getPendingCount: async (): Promise<number> => {
    const response = await adminApi.get<{ data: { count: number } }>(`${BASE}/pending-count`);
    return response.data.data.count;
  },

  resolveReport: async (id: number, request: ResolveReportRequest): Promise<BulkResolveResult> => {
    const response = await adminApi.put<{ data: BulkResolveResult }>(`${BASE}/${id}/resolve`, request);
    return response.data.data;
  },

  getSchoolsForResolution: async (councilId: number, schoolType: string): Promise<{ id: number; name: string }[]> => {
    const response = await adminApi.get<{ data: { id: number; name: string }[] }>(
      `/api/scottish-curriculum/schools`,
      { params: { councilId, schoolType } }
    );
    return response.data.data;
  },
};
